import angular from 'angular';
import 'ui-select';
import './userOrderServices';

const userOrderControllers = angular.module('applicationModule.userOrderControllers', ['applicationModule.userOrderServices', 'ui.select']);


userOrderControllers.controller('OrderListController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Order', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, NgTableParams, Order, AppsoupAPI, Permissions) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('orders');
    $scope.application_id = $stateParams.application_id;
    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;

            return Order.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);

                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
}]);

userOrderControllers.controller('OrderDetailController', ['$scope', '$rootScope', '$stateParams', '$state', 'Order', function ($scope, $rootScope, $stateParams, $state, Order) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.orderId = $stateParams.orderId;
    Order.getDetail($scope.orderId, $scope.application_id).then(function (response) {
        $scope.detail = response;
        $scope.detail.payment_info = angular.fromJson(response.payment_info);
        $scope.detail.products = angular.fromJson(response.products);
        $scope.detail.shipping_address = angular.fromJson(response.shipping_address);
    });

    $scope.back = function () {
        $state.go('appsoup.application.order');
    };

}]);

export default userOrderControllers;
